import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { JobService, Utils } from '../../../lib/services';
import { ContentService } from '../../../lib/services/contentService';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as fromRoot from '../../../reducers';
import { Store } from '@ngrx/store';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { SelectedJobState } from '../../../jobs-module/reducers/jobs.reducer';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'mj-job-social-media-preview',
  templateUrl: './job-social-media-preview.template.html',
  styleUrls: ['./job-social-media-preview.style.scss'],
})
export class JobSocialMediaPreviewComponent implements OnInit, OnChanges {
  @Input() jobState: SelectedJobState;

  copyText: string = '';
  copyTextAlt: string = '';
  jobShareUrl: string;

  constructor(
    public $u: Utils,
    public cs: ContentService,
    private _jobService: JobService,
    private store: Store<fromRoot.State>,
    private router: Router,
    private snackbar: MatSnackBar,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.translate
      .get('settings_career_side_copy_url')
      .pipe(take(1))
      .subscribe(msg => {
        this.copyText = msg;
      });
    this.translate
      .get('settings_career_side_copy_url_copied')
      .pipe(take(1))
      .subscribe(msg => {
        this.copyTextAlt = msg;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.jobState && this.jobState.job) {
      this.jobShareUrl =
        environment.jobShareUrl + this.jobState.job.publisher_linked_id;
    }
  }

  public copyUrl() {
    // Create new element
    const el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = this.jobShareUrl;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
    this.copyText = this.copyTextAlt;
  }
}
